import { logger } from 'modules/logger';
import type { SlateContent } from '../types';

export const sanitizeAddendumContentForPersistence = (content: SlateContent): SlateContent => {
  let removedHeadingErrorMarks = 0;

  const walk = (node: any): any => {
    if (node == null || typeof node !== 'object') return node;

    if (Array.isArray(node)) {
      return node.map(walk);
    }

    const cloned = { ...node };
    if ('headingError' in cloned) {
      delete cloned.headingError;
      removedHeadingErrorMarks++;
    }

    if (Array.isArray(cloned.children)) {
      cloned.children = cloned.children.map(walk);
    }

    return cloned;
  };

  const sanitizedContent = walk(content) as SlateContent;

  if (removedHeadingErrorMarks > 0) {
    logger.info('[Fields.Context] Sanitized addendum: removed headingError marks', {
      removedHeadingErrorMarks,
    });
  }

  return sanitizedContent;
};
